import React, { useState } from 'react'
import addeventsteponeStyle from './AddEventMobilStepOne.module.css'

export default function AddEventMobilStepOne({ onNext, nextLabel }) {
  return (
    <div className={addeventsteponeStyle.aemsOnepage}>
      <h4 className={addeventsteponeStyle.addeventtitleMobil}> Event </h4>
      <div className={addeventsteponeStyle.addeventmobilWrap}>
        <div className="row">
          <div className="col-12 mb-3">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>Event Name</label>
            <input type="text" className={`${addeventsteponeStyle.addeventmobilInput} form-control`} placeholder="Type name of event" />
          </div>
        </div>
        <div className="row">
          <div className="col-6 mb-3 pe-1">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>Start and End Date</label>
            <input type="text" className={`${addeventsteponeStyle.addeventmobilInput} form-control`} placeholder="Start Date" />
          </div>
          <div className="col-6 mb-3 ps-1">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>.</label>
            <input type="text" className={`${addeventsteponeStyle.addeventmobilInput} form-control`} placeholder="End Date" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>Event Details</label>
            <input type="text" className={`${addeventsteponeStyle.addeventmobilInput} form-control`} placeholder="Enter grade/age levels" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>Location</label>
            <input type="text" className={`${addeventsteponeStyle.addeventmobilInput} form-control`} placeholder="Enter location of event here" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <label className={`${addeventsteponeStyle.addeventmobilLabel} form-label`}>Notes</label>
            <textarea className={`${addeventsteponeStyle.addeventmobilInput} form-control`} rows="4" placeholder='If you have any additional notes or details you’d like to share with Bookworm Central, feel free to enter them here.'></textarea>
          </div>
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-12">
          <button className={`${addeventsteponeStyle.nextauthormobilButton} btn btn-primary w-100`} onClick={onNext}>{nextLabel}</button>
        </div>
      </div>
    </div>
  )
}

